document.addEventListener('DOMContentLoaded', function() {
  // Funktion zum Anzeigen des Modals
  function showAgeVerificationModal() {
    const modal = document.getElementById('ageCheck_modal');
    modal.style.display = 'block';
  }

  // Funktion zum Hinzufügen des Modals per HTML-Code
  function addAgeVerificationModal() {
    const modalHTML = `
      <div id="ageCheck_modal">
        <div class="ageCheck_modalContent">
          <div id="ageCheck_modalBorder">
            <img src="https://cdn.shopify.com/s/files/1/0614/8069/8044/files/elfbar600BayernRund.webp" 
                 alt="Logo" class="ageCheck_logo">
            <h2 class="ageCheck_heading">Bitte bestätige, ob du volljährig bist.</h2>
            <p class="ageCheck_text">
              Um auf dieser Seite einkaufen zu können, musst du das 18. Lebensjahr vollendet haben.
            </p>
            <button class="ageCheck_button ageCheck_yesButton" id="ageCheck_yesButton">Ja, ich bin über 18</button>
            <button class="ageCheck_button ageCheck_noButton" id="ageCheck_noButton">Seite verlassen</button>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  // Modal hinzufügen und anzeigen
  addAgeVerificationModal();
  showAgeVerificationModal();

  // Event-Listener für den "Ja, ich bin volljährig"-Button
  document.body.addEventListener('click', function(event) {
    if (event.target && event.target.id === 'ageCheck_yesButton') {
      // Leite den Benutzer zur Zielseite weiter, ohne das Modal zu schließen
      window.history.pushState({}, '', window.location.href); // Aktualisiert den Browser-Verlauf
      window.location.href = 'https://www.elfbar600.bayern'; // Weiterleitung zur Zielseite
    }
  });

  // Event-Listener für den "Abbrechen"-Button
  document.body.addEventListener('click', function(event) {
    if (event.target && event.target.id === 'ageCheck_noButton') {
      // Wenn der Benutzer auf Abbrechen klickt, wird die Seite zu Google umgeleitet
      window.location.href = 'https://www.google.de';
    }
  });

  // Event-Listener für den Browser-Back-Button
  window.addEventListener('popstate', function(event) {
    showAgeVerificationModal(); // Modal erneut anzeigen
  });
});
